mapboxgl.accessToken = 'pk.eyJ1IjoibGFrZXNzdXBwbHljbyIsImEiOiJjbW5kcjQyeWcxaWFnMnFxMWZoejZrZm4xIn0.GI7GNWwhpPWi_KkMRC4Q3Q';  

const states = {
  IA: { center: [-95.2, 42.6], zoom: 7 },
  MN: { center: [-94.5, 46], zoom: 6 },
  MO: { center: [-91.7, 39.5], zoom: 8 },
  ND: { center: [-100.6, 48], zoom: 7.5 },
  OH: { center: [-81.7, 42], zoom: 7.5 },
  OK: { center: [-94.9, 36.6], zoom: 7.5 },
  SD: { center: [-100.6, 44], zoom: 6.5 },
  WI: { center: [-89.6, 45], zoom: 4.5 },
  AB: { center: [-115.9, 51], zoom: 5.5 }
};

const stateNames = {
  IA: "Iowa",
  MN: "Minnesota",
  MO: "Missouri",
  ND: "North Dakota",
  OH: "Ohio",
  OK: "Oklahoma",
  SD: "South Dakota",
  WI: "Wisconsin",
  AB: "Alberta"
};

const map = new mapboxgl.Map({
  container: 'map',
  style: 'mapbox://styles/mapbox/outdoors-v12',
  center: [-94.5, 46],
  zoom: 6
});

let markers = [];
let lakesData = [];
let selectedState = '';
let selectedCounty = '';

// DOM
const stateDropdown = document.getElementById('stateDropdown');
const countyDropdown = document.getElementById('countyDropdown');
const resetBtn = document.getElementById('resetFilters');

// Render markers
function renderLakes(lakes) {
  markers.forEach(m => m.remove());
  markers = [];

  lakes.forEach(lake => {
    if (!lake.coords) return;

    const marker = new mapboxgl.Marker()
      .setLngLat(lake.coords)
      .setPopup(new mapboxgl.Popup().setHTML(`
  <div style="font-family:sans-serif; max-width:220px;">
    <h3 style="margin:0 0 6px 0;">${lake.name}</h3>

    ${
      lake.url
        ? `<a href="${lake.url}" style="
            display:block;
            margin-bottom:8px;
            font-size:13px;
            color:#2563eb;
            text-decoration:none;
          ">
            Shop this lake
          </a>`
        : ''
    }


  </div>
`))
      .addTo(map);

    markers.push(marker);
  });
}


// Filter logic
function filterAndRender() {
  let filtered = lakesData;

  // ✅ ALWAYS filter by state first
  if (selectedState) {
    filtered = filtered.filter(l => {
  return Array.isArray(l.state)
    ? l.state.includes(selectedState)
    : l.state === selectedState;
});
  }

  // ✅ THEN filter by county
  if (selectedCounty) {
    filtered = filtered.filter(l => {
      const matchesCounty = Array.isArray(l.county)
        ? l.county.includes(selectedCounty)
        : l.county === selectedCounty;

      return matchesCounty;
    });
  }

  renderLakes(filtered);

  // ✅ Zoom logic
  if (filtered.length === 1) {
  // 🎯 Single lake → zoom tight
  map.flyTo({
    center: filtered[0].coords,
    zoom: 11
  });
} 
if (filtered.length > 1) {
  const bounds = new mapboxgl.LngLatBounds();

  filtered.forEach(lake => {
    if (lake.coords && lake.coords.length === 2) {
      bounds.extend(lake.coords);
    }
  });

  if (!bounds.isEmpty()) {
    map.fitBounds(bounds, {
      padding: 100,
      maxZoom: 11,
      duration: 1000
    });
  }
}
}

// Build STATE dropdown
function buildStateDropdown() {
  const states = [...new Set(lakesData.map(l => l.state))];

  stateDropdown.innerHTML = `
    <div class="dropdown-selected">All States</div>
    <div class="dropdown-options">
      <div data-state="">All States</div>
      ${states.map(s => `<div data-state="${s}">${s}</div>`).join('')}
    </div>
  `;

  const selected = stateDropdown.querySelector('.dropdown-selected');
  const options = stateDropdown.querySelector('.dropdown-options');

  selected.onclick = () => {
    options.style.display = options.style.display === 'block' ? 'none' : 'block';
  };

  options.querySelectorAll('div').forEach(opt => {
    opt.onclick = () => {
      selected.textContent = opt.textContent;
      selectedState = opt.dataset.state || '';
      selectedCounty = '';

      buildCountyDropdown();
      filterAndRender();

      options.style.display = 'none';
    };
  });
}

// Build COUNTY dropdown
function buildCountyDropdown() {
  let filtered = lakesData;

  if (selectedState) {
    filtered = filtered.filter(l =>
      Array.isArray(l.state)
        ? l.state.includes(selectedState)
        : l.state === selectedState
    );
  }

  // Build unique county-state pairs
  const countyMap = new Map();

  filtered.forEach(l => {
    const countiesArr = Array.isArray(l.county) ? l.county : [l.county];
    const statesArr = Array.isArray(l.state) ? l.state : [l.state];

    countiesArr.forEach(c => {
      statesArr.forEach(s => {
        const key = `${c}|${s}`;
        countyMap.set(key, { county: c, state: s });
      });
    });
  });

  // Convert to array
  let countyList = [...countyMap.values()];

  // ✅ Sort by state, then county
  countyList.sort((a, b) => {
    if (a.state === b.state) {
      return a.county.localeCompare(b.county);
    }
    return a.state.localeCompare(b.state);
  });

  // ✅ Group by state
  const grouped = {};
  countyList.forEach(item => {
    if (!grouped[item.state]) {
      grouped[item.state] = [];
    }
    grouped[item.state].push(item);
  });

  // Build HTML
  let html = `
    <div class="dropdown-selected">All Counties</div>
    <div class="dropdown-options">
      <div data-county="">All Counties</div>
  `;

  Object.keys(grouped).forEach(state => {
    html += `<div class="dropdown-group-label">— ${stateNames[state] || state} —</div>`;

    grouped[state].forEach(c => {
      html += `
        <div data-county="${c.county}|${c.state}">
          ${c.county}
        </div>
      `;
    });
  });

  countyDropdown.innerHTML = html;

  const selected = countyDropdown.querySelector('.dropdown-selected');
  const options = countyDropdown.querySelector('.dropdown-options');

  selected.onclick = () => {
    options.style.display =
      options.style.display === 'block' ? 'none' : 'block';
  };

  options.querySelectorAll('div[data-county]').forEach(opt => {
    opt.onclick = () => {
      if (!opt.dataset.county) {
        selectedCounty = '';
        selected.textContent = 'All Counties';
      } else {
        const [county, state] = opt.dataset.county.split('|');

        selectedCounty = county;
        selectedState = state;
        selected.textContent = `${county} ${state}`;
      }

      filterAndRender();
      options.style.display = 'none';
    };
  });
}

// Reset
resetBtn.addEventListener('click', () => {
  selectedState = '';
  selectedCounty = '';

  buildStateDropdown();
  buildCountyDropdown();

  map.flyTo({ center: [-94.5, 46], zoom: 6 });
  renderLakes(lakesData);
});

// Load data
map.on('load', () => {

  // ✅ SOURCE
  map.addSource('all-lakes', {
    type: 'geojson',
    asset: '/mn-lakes-rectangles-full.geojson'
  });

  // ✅ LAYER
  map.addLayer({
    id: 'lake-hit-area',
    type: 'fill',
    source: 'all-lakes',
    paint: {
      'fill-color': '#000',
      'fill-opacity': 0
    },
    filter: ['>=', ['get', 'area_acres'], 150]
  });

  // ✅ HOVER
  map.on('mouseenter', 'lake-hit-area', () => {
    map.getCanvas().style.cursor = 'pointer';
  });

  map.on('mouseleave', 'lake-hit-area', () => {
    map.getCanvas().style.cursor = '';
  });

  // ✅ CLICK
  map.on('click', 'lake-hit-area', (e) => {
    const feature = e.features[0];
    const props = feature.properties;

    const lakeName = props.name || 'Unknown Lake';
    const county = props.county || 'MN';
    const state = 'MN';

    const normalize = (str) =>
      (str || '')
        .toLowerCase()
        .replace(/lake/g, '')
        .replace(/reservoir/g, '')
        .replace(/[^a-z]/g, '')
        .trim();

    const existingLake = lakesData.find(l =>
      normalize(l.name) === normalize(lakeName)
    );

    let popupHTML = `
      <div style="font-family:sans-serif; max-width:220px;">
        <h3 style="margin:0 0 6px 0;">${lakeName}</h3>
        <div style="font-size:12px; color:#666; margin-bottom:8px;">
          ${county} County
        </div>
    `;

    if (existingLake && existingLake.url) {
      popupHTML += `
        <a href="${existingLake.url}" style="
          display:inline-block;
          padding:8px 12px;
          background:#2563eb;
          color:#fff;
          text-decoration:none;
          border-radius:6px;
          font-size:13px;
        ">
          Shop this lake
        </a>
      `;
    } 
    else {
      popupHTML += `
        <a href="https://lakessupply.com/pages/contact"
           style="
             display:inline-block;
             padding:8px 12px;
             background:#1f2937;
             color:#fff;
             text-decoration:none;
             border-radius:6px;
             font-size:13px;
           ">
           Request (coming soon)
        </a>
      `;
    }

    popupHTML += `</div>`;

    new mapboxgl.Popup()
      .setLngLat(e.lngLat)
      .setHTML(popupHTML)
      .addTo(map);
  });

  // ✅ LOAD YOUR DATA
  fetch(window.LAKES_JSON_URL)
    .then(res => res.json())
    .then(data => {
      lakesData = data;

      buildStateDropdown();
      buildCountyDropdown();
      renderLakes(lakesData);
    });

});


fetch(window.LAKES_JSON_URL)
    .then(res => res.json())
    .then(data => {
      lakesData = data;

      buildStateDropdown();
      buildCountyDropdown();
      renderLakes(lakesData);
    });

// Drawer fix
function toggleFiltersForDrawer() {
  const filters = document.querySelector('.filters');
  const drawer = document.querySelector('.mobile-menu, .drawer, .menu-drawer');

  if (!filters || !drawer) return;

  const isOpen = window.getComputedStyle(drawer).display !== 'none' &&
                 drawer.offsetWidth > 0;

  filters.style.display = isOpen ? 'none' : 'block';
}

// Run on load
setInterval(toggleFiltersForDrawer, 300);
